module.exports = __webpack_public_path__ + "img/bgZj.1d89fc4a.png";